import { useChapterHistoryTableController } from './ChapterHistoryTableController';
import styles from './ChapterHistoryTable.module.scss';
import CustomButton from '../../../../../components/stateless/customButton/CustomButton';
import CustomDialog from '../../../../../components/stateless/dialog/CustomDialog';
import { ChapterHistoryTableTypes } from '../../../../../utilities/enums';

interface IChapterHistoryTable {
    chapter: any;
    chapterHistory: any;
    reloadChapterHistory: any;
}

const ChapterHistoryTable = (props: IChapterHistoryTable) => {
    const { chapter, chapterHistory, reloadChapterHistory } = props;

    const { pendingDeleteId, recordStatuses, downloadPdf, handleDeleteConfirm, setPendingDeleteId } = useChapterHistoryTableController(
        chapter,
        reloadChapterHistory,
    );

    return (
        <div className={styles.historyItemsContainer}>
            <h3>
                <b>{ChapterHistoryTableTypes.historyTableTitle}</b>
            </h3>
            {chapterHistory.map((item: any, index: number) => (
                <div className={styles.historyItem} key={`chapter-history-${item.id}-${index}`}>
                    {item.pdfContainerName && item.pdfBlobName && (
                        <div className={styles.btnContainer}>
                            <CustomButton
                                onClick={() => {
                                    downloadPdf(item.pdfContainerName, item.pdfBlobName);
                                }}
                                themeColor="success"
                                size="small"
                                icon="pdf"
                            />
                        </div>
                    )}
                    <div className={styles.detailsContainer}>
                        {item.recordStatusId && (
                            <div className={styles.recordStatusContainer}>
                                <div className={styles.recordStatusLabel}>Action:</div>
                                <div className={styles.recordStatus}>
                                    {recordStatuses.find((status) => status.id === item.recordStatusId)
                                        ?.recordStatusName ?? null}
                                </div>
                            </div>
                        )}
                        {item.effectiveFrom && item.effectiveTo && (
                            <div className={styles.effectiveDateContainer}>
                                <div className={styles.effectiveDateLabel}>
                                    {ChapterHistoryTableTypes.EffectiveLabel}
                                </div>
                                <div className={styles.effectiveDate}>
                                    {new Date(item.effectiveFrom).toDateString()} -{' '}
                                    {new Date(item.effectiveTo).toDateString()}
                                </div>
                            </div>
                        )}
                        {item.effectiveFrom && !item.effectiveTo && (
                            <div className={styles.effectiveDateContainer}>
                                <div className={styles.effectiveDateLabel}>
                                    {ChapterHistoryTableTypes.EffectiveLabel}
                                </div>
                                <div className={styles.effectiveDate}>
                                    {new Date(item.effectiveFrom).toDateString()} - current
                                </div>
                            </div>
                        )}
                    </div>
                    <div style={{ marginLeft: '5px', display: 'flex' }}>
                        <CustomButton
                            onClick={() => setPendingDeleteId(item.id)}
                            themeColor="error"
                            size="small"
                            icon="delete"
                        />
                    </div>
                </div>
            ))}
            <CustomDialog
                open={pendingDeleteId !== null}
                title={ChapterHistoryTableTypes.DeleteHistoryItemTitle}
                toggleDialog={() => setPendingDeleteId(null)}
                size="small"
                yesNo
                approveAction={handleDeleteConfirm}
                cancelAction={() => setPendingDeleteId(null)}
            >
                <p>{ChapterHistoryTableTypes.DeleteHistoryItemWarning}</p>
            </CustomDialog>
        </div>
    );
};

export default ChapterHistoryTable;
